import React, { useState, useEffect, useContext } from 'react';
import { /*makeStyles,*/ Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { unsubscribeRealtimeUpdates } from './system/firebase';
import { COMPOSITE_DOC_ID_DELIMITER } from './system/constants';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { loadAlertsById } from './common/services/appServices';
import { AppContext } from './common/contexts';
import {
    ALERT_NEW_MESSAGE,
    ALERT_NEW_PENDING_INTERVIEW,
    ALERT_NEW_RESCHEDULED_INTERVIEW,
    ALERT_NEW_CONFIRM_INTERVIEW,
    ALERT_NEW_DECLINED_INTERVIEW,
    ALERT_NEW_JOB_APPLICATION,
    ALERT_NEW_INTERNAL_MESSAGE,
} from './common/constants';

// import _get from 'lodash/get';

// const userId = 'ekOVkRuQj1evtfnLsoHVfyeia632';

const handCloseSnackbar = setOpen => {
    setOpen(false);
};

const UserAlerts = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const appContext = useContext(AppContext);
    const { userId, employerId } = appContext;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState(false);
    const [messages, setMessages] = useState([]);
    const [alertData, setAlertData] = useState();
    const [alertDataEmpMember, setAlertDataEmpMember] = useState();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { autoHideDuration = 3000, ...otherProps } = props;

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const isEmp = !!employerId;
    const alertDocId = isEmp ? employerId : userId;
    const empMemberUserId = isEmp ? userId : null;

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // listener for user's or employer's alerts
    useEffect(() => {
        let unsubscribeLoadAlertsById = null;
        if (alertDocId) {
            unsubscribeLoadAlertsById = loadAlertsById({ docId: alertDocId, setData: setAlertData });
        }

        // unsubscribe realtime update on unmount
        return () => {
            unsubscribeRealtimeUpdates([unsubscribeLoadAlertsById]);
        };
    }, [alertDocId]);

    // listener for employer member's alerts
    useEffect(() => {
        let unsubscribeLoadAlertsById = null;
        if (employerId && empMemberUserId) {
            unsubscribeLoadAlertsById = loadAlertsById({ docId: `${empMemberUserId}${COMPOSITE_DOC_ID_DELIMITER}${employerId}`, setData: setAlertDataEmpMember });
        }

        // unsubscribe realtime update on unmount
        return () => {
            unsubscribeRealtimeUpdates([unsubscribeLoadAlertsById]);
        };
    }, [employerId, empMemberUserId]);

    // set up alerts
    useEffect(() => {
        let newMessages = [];

        // console.log('%c@@@@ UserAlerts useEffect [alertData] START alertData=', 'background: #222; color: #bada55', alertData);
        if (alertData) {
            // console.log('%c@@@@ UserAlerts useEffect [alertData] inside IF', 'background: #222; color: #bada55');

            if (alertData.newJobApplicationAlert === true) {
                newMessages.push(ALERT_NEW_JOB_APPLICATION);
            }

            if (alertData.newMessageAlert === true) {
                newMessages.push(ALERT_NEW_MESSAGE);
            }

            if (alertData.pendingInterviewAlert === true) {
                newMessages.push(ALERT_NEW_PENDING_INTERVIEW);
            }

            if (alertData.rescheduleInterviewAlert === true) {
                newMessages.push(ALERT_NEW_RESCHEDULED_INTERVIEW);
            }

            if (alertData.confirmInterviewAlert === true) {
                newMessages.push(ALERT_NEW_CONFIRM_INTERVIEW);
            }

            if (alertData.declineInterviewAlert === true) {
                newMessages.push(ALERT_NEW_DECLINED_INTERVIEW);
            }
        }

        if (alertDataEmpMember) {
            if (alertDataEmpMember.newMessageAlert === true) {
                newMessages.push(ALERT_NEW_INTERNAL_MESSAGE);
            }
        }

        if (newMessages.length > 0) {
            // console.log('%c@@@@ UserAlerts useEffect [alertData] newMessages.length > 0', 'background: #222; color: #bada55');
            setMessages(newMessages);
        }
    }, [alertData, alertDataEmpMember]);

    useEffect(() => {
        // console.log('%c@@@@ UserAlerts useEffect [messages, message, open] START', 'background: #222; color: #bada55');
        // console.log('%c@@@@ UserAlerts useEffect [messages, message, open] messages=', 'background: #222; color: #bada55', messages);
        // console.log('%c@@@@ UserAlerts useEffect [messages, message, open] message=', 'background: #222; color: #bada55', message);
        // console.log('%c@@@@ UserAlerts useEffect [messages, message, open] open=', 'background: #222; color: #bada55', open);

        if (messages.length && !message) {
            // console.log('%c@@@@ UserAlerts useEffect [messages, message, open] inside FIRST if', 'background: #222; color: #bada55');

            setMessage(messages[0]);
            setMessages(prev => prev.slice(1));
            setOpen(true);
        } else if (messages.length && open === false) {
            // console.log('%c@@@@ UserAlerts useEffect [messages, message, open] inside SECOND if', 'background: #222; color: #bada55');

            setMessage(messages[0]);
            setMessages(prev => prev.slice(1));
            setOpen(true);
        }
    }, [messages, message, open]);

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Snackbar
            autoHideDuration={autoHideDuration}
            open={open}
            onClose={handCloseSnackbar.bind(null, setOpen)}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            {...otherProps}
        >
            <Alert variant="filled" iconMapping={{ success: <CheckCircleOutlineIcon fontSize="inherit" /> }}>
                {message}
            </Alert>
        </Snackbar>
    );
};

export default UserAlerts;
